// extracted by mini-css-extract-plugin
export default {"topbtn":"scroll_topbtn__bIbz0","icon":"scroll_icon__xwO6X","gototop":"scroll_gototop__SCqPr"};